import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-daily-sale-product-wise',
  templateUrl: './daily-sale-product-wise.component.html',
  styleUrls: ['./daily-sale-product-wise.component.scss']
})
export class DailySaleProductWiseComponent implements OnInit {

  from_date: any = null;
  to_date: any = null;
  title: any;
  data_loading = false;
  sale_date_list = [];
  sale_data = null;
  is_data_available = false;
  disable_update_button = true;
  document_file: any;

  constructor(private globalService: GlobalService, private httpService: HttpService) {
    this.title = this.globalService._active_display_name;
  }

  serveDailySale() {
    this.disable_update_button = true;
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date
    }
    console.log(data_dict);
    this.data_loading = true;
    this.is_data_available = false;
    this.httpService.serveDailySaleQuantityProductWise(data_dict).subscribe((data) => {
      this.data_loading = false;
      if (data['available']) {
        this.is_data_available = true;
        this.sale_date_list = data['date_list'];
        this.sale_data = data['sale_dict'];
        this.document_file = data['document'];
      } else {
        alert ('Data not available');
        return false;
      }
      console.log(data);
    }, (error) => {
      this.is_data_available = false;
      this.data_loading = false;
      console.error(error);
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  ngOnInit() {
  }

}
